import React, {Component} from 'react';
import 'react-dates/lib/css/_datepicker.css';
require(`../assets/${process.env.PAGE}/css/custom-date-picker.css`);
import DynamicLabelInput from './DynamicLabelInput';


  // CSS Modules, react-datepicker-cssmodules.css
  // import 'react-datepicker/dist/react-datepicker-cssmodules.css';

class CustomDatePicker extends Component {
    constructor (props) {
        super(props)
        this.state = {
            focused: false
        }
    }

    render() {
        const {input, label, renderMonthElement, showSuccess, meta: { touched, error, valid, invalid, warning }} = this.props;

        return (
            <div className={`form-group ${touched && invalid ? 'has-error' : ''} ${touched && valid && showSuccess ? 'has-success' : ''}`}>
                <DynamicLabelInput
                    {...input}
                    renderMonthElement={renderMonthElement}
                    type={'calendar'}
                    focused={this.state.focused}
                    placeholder={label}
                    showLabel={['montemar', 'ftyc', 'juncal'].includes(process.env.PAGE)}
                    onFocusChange={({ focused }) => this.setState({ focused })}
                />
                <div className="help-block">
                {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
                </div>
            </div>
        );
    }
}

export default CustomDatePicker;


/** WEBPACK FOOTER **
 ** ./src/components/CustomDatePicker.js
 **/